import { Component, Inject } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RegionVariantService } from 'app/core/region-variant/region-variant.service';
import { IntlDateAdapter } from '../intl-date-adapter';
import { endOfDay, startOfDay } from 'app/core/utils/date-util';

export interface DateRangeDialogData {
  /** Action buttons.  Default is ['Ok', 'Cancel'] */
  actions?: string[];
  /** Initial start date */
  startDate?: Date;
  /** Initial end date */
  endDate?: Date;
  /** Title of dialog box */
  title?: string;
  /** Validates input.  Ok (first) button is disabled if it returns false.  Default function validates that end >= start. */
  validFn?: (start: Date, end: Date) => boolean;
}

export interface DateRangeDialogResult {
  /** Action button selected by the user, e.g. 'Ok' */
  selectedAction: string;
  /** Start date entered by the user */
  startDate: Date;
  /** Start date entered by the user */
  endDate: Date;
}

@Component({
  selector: 'date-range-dialog',
  templateUrl: './date-range-dialog.component.html',
  providers: [
    MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER,
    { provide: DateAdapter, useClass: IntlDateAdapter, deps: [MAT_DATE_LOCALE, RegionVariantService] },
  ]
})
export class DateRangeDialogComponent {
  data: DateRangeDialogData;

  constructor(
    public dialogRef: MatDialogRef<DateRangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: DateRangeDialogData
  ) {
    this.data = { ...data };
    this.data.actions = data.actions || ['Ok', 'Cancel'];
    this.data.validFn = 
      data.validFn || ((start, end) => start?.getTime && end?.getTime && end.getTime() >= start.getTime());
  }

  onAction(action: string): void {
    const result = {
      selectedAction: action,
      startDate: this.data.startDate ? startOfDay(this.data.startDate) : null,
      endDate: this.data.endDate ? endOfDay(this.data.endDate) : null,
    } as DateRangeDialogResult;
    this.dialogRef.close(result);
  }
}
